module.exports = __webpack_public_path__ + "static/media/fill_white_32.601ffc86.svg";